/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable lines-between-class-members */
/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unused-vars */
import 'reflect-metadata';
import { AxiosRequestConfig } from 'axios';
import toastr from 'toastr';
import {
  FeignClient,
  FeignErrorHandler,
  Get,
  Post,
  Put,
  Patch,
  Delete,
  Param,
  Query,
  Body,
  Form,
} from '../../@jms-react/common/feign';
import { Header } from '../../@jms-react/common/feign/method.decorator';

const baseConfig = (): AxiosRequestConfig => {
  return {
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000 * 10,
    headers: {
      Authorization: window.localStorage.getItem('token') ?? undefined,
    },
  };
};

const errorHandler = (error: any) => {
  const { status, data } = error;
  if (status) {
    if (status === 401) {
      alert('보안을 위하여 다시 로그인해 주시기 바랍니다.');
      window.location.href = `${process.env.REACT_APP_CONTEXT ?? ''}/login`;
    }
  }

  let message = data?.message || error.message;
  if (message) {
    if (Array.isArray(message)) {
      message = message.join('\n');
    }

    showErrorMessage(message);
  }
};

const showErrorMessage = (message: string, title?: string) => {
  toastr.error(message, title ?? 'Error', {
    positionClass: 'toast-top-center',
    closeButton: true,
    tapToDismiss: false,
    progressBar: true,
    timeOut: 5000,
  });
};

@FeignClient(baseConfig, errorHandler)
class Server {
  /*
   * 로그인 및 토큰발급
   */
  @Post('/signin')
  async signin(@Body() data: { id: string; password: string }): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 회원가입
   */
  @Post('/signup')
  async signup(
    @Body()
    data: {
      name: any;
      username: any;
      email: string;
      part: string;
      password: string;
      post: string;
      address: string;
      tel: string;
      phone: string;
      college: string;
      department: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 회원정보 변경
   */
  @Patch('/users/own')
  async patchUserInfo(
    @Body()
    data: {
      part: string;
      password: string;
      email: string;
      tel: string;
      phone: string;
      address: string;
      college: string;
      department: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 회원탈퇴
   */
  @Delete('/users/own')
  async deleteUserOwn(
    @Body()
    data: {
      password: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 아이디(ID) 중복 검색
   */
  @Get('/users/search')
  async searchUserName(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('id') id: string,
    @Query('part') part?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 주소(우편번호) 검색
   */
  @Get('/zipcode')
  async getPostcode(
    @Param('page') page: number,
    @Query('limit') limit: number,
    @Query('keyword') keyword: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* --
   * 카테고리 목록조회
   */
  @Get('/book-categories')
  async getCategories(): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   *  도서 엑셀 다운로드
   */
  @Get('/books/excel')
  async booksExcelDownload(): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* --1
   * 카테고리 도서 목록조회
   */
  @Get('/book-categories/{id}/books')
  async getBooksCategories(
    @Param('id') id: number,
    @Query('page') page?: number,
    @Query('limit') limit?: number,
    @Query('displayflag') displayflag?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* --2
   * 카테고리 도서 상세조회
   */
  @Get('/books/{id}')
  async getBookDetail(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 카테고리 추가
   */
  @Post('/book-categories')
  async addBookCategory(
    @Body() data: { name: string; displayOrder?: number; parentId?: number }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 카테고리 수정
   */
  @Patch('/book-categories/{id}')
  async modBookCategory(
    @Param('id') id: number,
    @Body() data: { name: string; displayOrder?: number; parentId?: number }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 카테고리 조회
   */
  @Get('/book-categories/{id}')
  async getBookCategory(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 카테고리 삭제
   */
  @Delete('/book-categories/{id}')
  async deleteBookCategory(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /* --
   * 게시물 조회
   */
  @Get('/board/{ctgy}')
  async getBoardList(
    @Param('ctgy') ctgy: string,
    @Query('page') page: number,
    @Query('limit') limit: number
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* --
   * 단일 게시물 조회
   */
  @Get('/board/{ctgy}/{id}')
  async getBoardItem(@Param('ctgy') ctgy: string, @Param('id') id: string): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* --
   * 게시물 검색
   */
  @Get('/board/{ctgy}/search')
  async searchBoardList(
    @Param('ctgy') ctgy: string,
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('subject') subject?: string,
    @Query('writer') writer?: string,
    @Query('content') content?: string,
    @Query('all') all?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 게시물 등록
   */
  @Post('/board/{ctgy}')
  async writeBoard(
    @Param('ctgy') ctgy: string,
    @Body()
    data: {
      subject: string;
      content: string;
      link: string;
      attach1?: string;
      attach2?: string;
      attach3?: string;
      attach4?: string;
      attach5?: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 도서 등록
   */
  @Post('/books')
  async createBooks(
    @Body()
    data: {
      category: number;
      name: string;
      size: string;
      isbn: string;
      pageCount: number;
      college: string;
      author: string;
      authorIntroduce: string;
      introduce: string;
      contents: string;
      qty: number;
      point: number;
      price: number; // 판매가
      priceFull: number;
      priceMember: number;
      priceNonmember: number;
      flagType: string;
      flagEdition: string;
      isMain: string;
      isBest: string;
      isNew: string;
      isRecommendation: string;
      isDisplay: string;
      isColor: string;
      hasCd: string;
      hasVideo: string;
      urlYoutube: string;
      urlBlog: string;
      urlMovie: string;
      publicationDate: string;
      publisher: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 도서 수정
   */
  @Patch('/books/{id}')
  async updateBook(
    @Param('id') id: number,
    @Body()
    data: {
      category: number;
      name: string;
      size: string;
      isbn: string;
      pageCount: number;
      college: string;
      author: string;
      authorIntroduce: string;
      introduce: string;
      contents: string;
      qty: number;
      point: number;
      price: number;
      priceFull: number;
      priceMember: number;
      priceNonmember: number;
      flagType: string;
      flagEdition: string;
      isMain: string;
      isBest: string;
      isNew: string;
      isRecommendation: string;
      isDisplay: string;
      isColor: string;
      hasCd: string;
      hasVideo: string;
      urlYoutube: string;
      urlBlog: string;
      urlMovie: string;
      publicationDate: string;
      publisher: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 도서 파일 upload
   */
  @Patch('/books/{id}/attaches')
  async fileUploadBooks(
    @Param('id') id: number,
    @Form()
    data: any
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 도서 파일 삭제
   */
  @Delete('/books/{id}')
  async fileDeleteBooks(
    @Param('id') id: number,
    @Form()
    data: any
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 댓글 등록
   */
  @Post('/board/{ctgy}/{id}/reply')
  async writeReplyBoard(
    @Param('ctgy') ctgy: string,
    @Param('id') id: string,
    @Body()
    data: {
      subject: string;
      content: string;
      attach1?: string;
      attach2?: string;
      attach3?: string;
      attach4?: string;
      attach5?: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 댓글 가져오기
   */

  @Get('/board/ctgy/reply/{id}')
  async getReplyId(@Param('id') id: string): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 댓글 삭제
   */
  @Delete('/board/{ctgy}/reply/{id}')
  async deleteReply(@Param('ctgy') ctgy: string, @Param('id') id: string): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 댓글 수정
   */
  @Patch('/board/{ctgy}/reply/{id}')
  async updateReply(
    @Param('ctgy') ctgy: string,
    @Param('id') id: string,
    @Body()
    data: {
      subject: string;
      content: string;
      // attach1: string;
      // attach2: string;
      // attach3: string;
      // attach4: string;
      // attach5: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 게시글 수정
   */
  @Patch('/board/{ctgy}/{id}')
  async updateBoard(
    @Param('ctgy') ctgy: string,
    @Param('id') id: string,
    @Body()
    data: {
      subject: string;
      content: string;
      link: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 게시글 삭제
   */
  @Delete('/board/{ctgy}/{id}')
  async deleteBoard(@Param('ctgy') ctgy: string, @Param('id') id: string): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 도서 목록 조회
   */
  @Get('/books')
  async getBooks(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 메인/Best/신간/추천/전시/컬러 도서 목록 조회
   */
  @Get('/books/separator')
  async getBookIs(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('isMain') isMain: string,
    @Query('isBest') isBest: string,
    @Query('isNew') isNew: string,
    @Query('isRecommendation') isRecommendation: string,
    @Query('isDisplay') isDisplay: string,
    @Query('isColor') isColor: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 도서 목록 검색
   */
  @Get('/books/search')
  async searchBooks(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('name') name?: string,
    @Query('introduce') introduce?: string,
    @Query('author') author?: string,
    @Query('all') all?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 도서 목록 검색
   */
  @Get('/books/main/search')
  async searchMainBooks(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('name') name: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* --
   * 전체 도서 목록
   */
  @Get('/books')
  async AllBookList(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* --
   * 전체 도서 목록 검색
   */
  @Get('/books/search')
  async AllBookListSearch(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('name') name: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* 견본 도서 가져오기 */
  @Get('/sample-books')
  async getAllSampleBook(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
    견본 도서 검색 
  */
  @Get('/sample-books/search')
  async searchSampleBook(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('bookname') bookname?: string,
    @Query('college') college?: string,
    @Query('professor') professor?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* 견본 도서 삭제 */
  @Delete('/sample-books/{id}')
  async deleteSampleBook(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /* 견본 도서 상태 변경 */
  @Patch('/sample-books/{id}')
  async stateUpdateSampleBook(@Param('id') id: number, @Body() data: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 견본 도서 신청
   */
  @Post('/sample-books')
  async requestSampleBook(
    @Body()
    data: {
      isbn: string;
      bookCount: number;
      phone: string;
      email: string;
      post: string;
      address: string;
      content: string;
      bookId: number;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 도서 삭제
   */
  @Delete('/books/{id}')
  async deleteBook(@Param('id') id: string): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 도서별 판매 통계
   */
  @Get('/orders/statistics')
  async getOrderStatistics(
    @Query('startDate') startDate: string,
    @Query('endDate') endDatet: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원별 판매 통계
   */
  @Get('/users/statistics')
  async getMemberStatistics(
    @Query('startDate') startDate: string,
    @Query('endDate') endDatet: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원별 통계 중 특정회원 상세보기
   */
  @Get('/users/statistics/{id}')
  async getMemberStatisticsDetail(@Param('id') id: string): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 메인배너 조회
   * 관리자 - 메인배너 조회
   */
  @Get('/system/banner')
  async getBanners(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 배너 등록
   */
  @Post('/system/banner')
  async InsertBanner(
    @Body()
    data: {
      siteUrl: string;
      college: string;
      target: string;
      flag: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   *  관리자 - 배너 단일 조회
   */
  @Get('/system/banner/{id}')
  async getBanner(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 배너 수정
   */
  @Patch('/system/banner/{id}')
  async updateBanner(
    @Param('id') id: number,
    @Body()
    data: {
      siteUrl: string;
      college: string;
      target: string;
      flag: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 배너 이미지 등록
   */
  @Patch('/system/banner/{id}/attaches')
  async updateBannerAttache(
    @Param('id') id: number,
    @Form()
    data: any
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 배너 이미지 삭제
   */
  @Delete('/system/banner/{id}/attaches')
  async removeBannerAttache(
    @Param('id') id: number,
    @Body()
    data: any
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 배너 삭제
   */
  @Delete('/system/banner/{id}')
  async deleteBanner(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 반품환불정보 조회
   */
  @Get('/system/policy/refund')
  async getRefund(): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 반품환불정보 등록
   */
  @Post('/system/policy/refund')
  async updateRefund(
    @Body()
    data: {
      content1: string;
      content2: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 광고 조회
   */
  @Get('/system/advertisement')
  async getAdvertisements(
    @Query('page') page: number,
    @Query('limit') limit: number
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 광고 단일 조회
   */
  @Get('/system/advertisement/{id}')
  async getAdvertisement(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 광고 등록
   */
  @Post('/system/advertisement')
  async addAdvertisements(
    @Body() data: { sort: number; siteUrl: string; college: string; target: string }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 광고 수정
   */
  @Patch('/system/advertisement/{id}')
  async updateAdvertisements(
    @Param('id') id: number,
    @Body()
    data: {
      sort: number;
      siteUrl: string;
      college: string;
      target: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 광고 삭제
   */
  @Delete('/system/advertisement/{id}')
  async deleteAdvertisements(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 광고 파일 업로드
   */
  @Patch('/system/advertisement/{id}/attaches')
  async AdvertisementsFileUpload(@Param('id') id: number, @Form() data: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 광고 파일 삭제
   */
  @Delete('/system/advertisement/{id}/attaches')
  async AdvertisementsFileDelete(@Param('id') id: number, @Body() data: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 게시글 파일 upload
   */
  @Patch('/board/{ctgy}/{id}/attaches')
  async uploadAttaches(
    @Form()
    data: any,
    @Param('ctgy') ctgy: string,
    @Param('id') id: number
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 파일 삭제
   */
  @Delete('/board/{ctgy}/{id}/attaches')
  async deleteAttaches(
    @Param('ctgy') ctgy: string,
    @Param('id') id: string,
    @Body() data: any
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 본인 회원정보 조회
   */
  @Get('/users/own')
  async getUserOwn(): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 전체 회원목록 조회
   */
  @Get('/users')
  async getUsers(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 id 조회
   */
  @Get('/users/{id}')
  async getUserId(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 구분별(일반/교수/저자/관리자) 회원목록 조회
   */
  @Get('/users')
  async getUsersPart(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('part') part: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (전체)
   */
  @Get('/users/search')
  async searchUserAll(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('all') all: string,
    @Query('part') part?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (part별)
   */
  @Get('/users/search/part')
  async searchUser(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('all') all: string,
    @Query('part') part?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (이름)
   */
  @Get('/users/search/part')
  async searchUserRealName(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('name') name: string,
    @Query('part') part?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (이름)
   */
  @Get('/users/search')
  async searchUsersName(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('name') name: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (ID)
   */
  @Get('/users/search/part')
  async searchUserId(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('id') id: string,
    @Query('part') part?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (학교명)
   */
  @Get('/users/search/part')
  async searchUserCollege(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('college') college: string,
    @Query('part') part?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (학교명)
   */
  @Get('/users/search')
  async searchUsersCollege(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('college') college: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (학과)
   */
  @Get('/users/search/part')
  async searchUserDept(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('dept') dept: string,
    @Query('part') part?: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 검색 (학과)
   */
  @Get('/users/search')
  async searchUsersDept(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('dept') dept: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 회원 구분(일반/교수/저자/관리자) 변경
   */
  @Patch('/users/{id}')
  async patchUser(
    @Param('id') id: string,
    @Body()
    data: {
      part: string;
      password?: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 괸리자 - 회원 삭제
   */
  @Delete('/users/{id}')
  async deleteUser(@Param('id') id: string): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - DashBoard 조회
   */
  @Get('/board/statistics')
  async getDashBoardStatistics(): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 장바구니 조회
   */
  @Get('/orders/own/cart')
  async getCart(): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 장바구니 추가
   */
  @Post('/orders/own/cart')
  async postCart(
    @Body()
    data: {
      bookCode: number;
      categoryCode: number;
      bookName: string;
      bookImage: string;
      bookqty: number;
      bookPrice: number;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 장바구니 아이템 제거
   */
  @Delete('/orders/own/cart/{id}')
  async deleteCart(@Param('id') id: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 주문내역 조회
   */
  @Get('/orders/own')
  async getShippingOwn(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 주문하기 (장바구니에서 주문하기로)
   */
  @Post('/orders/buyings')
  async postOrders(
    @Body()
    data: any
    // data: {
    //   orderUserName: string;
    //   bookCode: string;
    //   bookName: string;
    //   bookPrice: number;
    //   purchaserName: string;
    //   purchaserEmail: string;
    //   orderQty: number;
    //   purchaserTel: string;
    //   purchaserPhone: string;
    //   post: string;
    //   addr: string;
    //   receiverName: string;
    //   receiverEmail: string;
    //   receiverTel: string;
    //   receiverPhone: string;
    //   receiverPost: string;
    //   receiverAddr: string;
    //   paymentOption: string;
    //   paymentAmount: number;
    //   payer: string;
    //   yeyakDate: Date;
    //   etc: string;
    //   bank: string;
    //   bankhost: string;
    //   point: number;
    //   usepoint: number;
    //   paymentDate: Date;
    //   payState: string;
    //   sDate: Date;
    //   salesPrice: number;
    //   jumunSun: string;
    //   memGbn: string;
    // }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 주문하기 (바로구매 : 단일품목)
   */
  @Post('/orders/buying')
  async postOrder(
    @Body()
    data: {
      orderUserName: string;
      bookCode: string;
      bookName: string;
      bookPrice: number;
      purchaserName: string;
      purchaserEmail: string;
      orderQty: number;
      purchaserTel: string;
      purchaserPhone: string;
      post: string;
      addr: string;
      receiverName: string;
      receiverEmail: string;
      receiverTel: string;
      receiverPhone: string;
      receiverPost: string;
      receiverAddr: string;
      paymentOption: string;
      paymentAmount: number;
      payer: string;
      yeyakDate: Date;
      etc: string;
      bank: string;
      bankhost: string;
      point: number;
      usepoint: number;
      paymentDate: Date;
      payState: string;
      sDate: Date;
      salesPrice: number;
      jumunSun: string;
      memGbn: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 주문내역 조회
   */
  @Get('/orders')
  async getOrderList(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 주문내역 상태 검색
   */
  @Get('/orders/search')
  async searchOrderState(
    @Query('state') state: string,
    @Query('page') page: number,
    @Query('limit') limit: number
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 주문내역 상태별 조회
   */
  @Get('/orders/admin/state')
  async getOrderState(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('payState') payState: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 주문내역 상태 변경
   */
  @Patch('/orders/{orderCode}/{jumunCode}')
  async patchOrderState(
    @Param('orderCode') orderCode: string,
    @Param('jumunCode') jumunCode: string,
    @Body()
    data: {
      payState: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 배송관리(배송비) 조회
   */
  @Get('/orders/delivery-fee')
  async getDelivery(): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 배송관리(배송비) 변경
   */
  @Patch('orders/delivery-fee')
  async patchDelivery(
    @Body()
    data: {
      beyandDf: string;
      stpayDf: string;
      stpayDf1: string;
      masterId: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 공동구매 신청
   */
  @Post('/orders/power-buying')
  async postGroupBuying(
    @Body()
    data: {
      college: string;
      dept: string;
      grade: string;
      professorLecture: string;
      email: string;
      phone: string;
      post: number;
      addr: string;
      books: { id: string; qty: number }[];
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 공동구매 현황 전체 조회
   */
  @Get('/orders/power-buying')
  async getGroupBuying(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 공동구매 현황 검색
   */
  @Get('/orders/power-buying/search')
  async searchGroupBuying(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('name') name: string,
    @Query('college') college: string,
    @Query('dept') dept: string,
    @Query('startDate') startDate: string,
    @Query('endDate') endDate: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 공동구매 특정 ID 조회
   */
  @Get('/orders/power-buying/{id}')
  async getGroupBuyingId(@Param('id') id: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 공동구매 특정 ID 상세 조회
   */
  @Get('/orders/power-buying/detail/{id}')
  async getGroupBuyingDetail(@Param('id') id: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 공동구매 특정 ID 수정 (견적 관련)
   */
  @Patch('/orders/power-buying/{id}')
  async patchGroupBuyingDetail(
    @Param('id') id: any,
    @Body()
    data: {
      effectiveDate: any;
      orderState: any;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 공동구매 특정 ID 수정 (상품 관련)
   */
  @Patch('/orders/power-buying/{id}/book/{bookId}')
  async patchGroupBuyingBook(
    @Param('id') id: any,
    @Param('bookId') bookId: any,
    @Body()
    data: {
      discountRate: any;
      discountPrice: any;
      amount: any;
      qty: any;
      totalAmount: any;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 공동구매 특정 ID 삭제
   */
  @Delete('/orders/power-buying/{id}')
  async deleteGroupBuyingDetail(@Param('id') id: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 출판 문의 리스트 조회
   */
  @Get('/publicationqna')
  async getAllPublication(
    @Query('page') page: number,
    @Query('limit') limit: number
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 출판 문의 검색
   */
  @Get('/publicationqna/search')
  async searchPublication(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Query('name') name: string
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 출판 문의 신청 - 비로그인
   */
  @Post('/publicationqna')
  async addPublication(
    @Body() data: { name: string; tel: string; phone: string; email: string; contents: string }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 출판 문의 삭제
   */
  @Delete('/publicationqna/{id}')
  async deletePublication(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 사용자 - 협력사 및 교육기관 조회
   */
  @Get('/system/banner/separate/{flag}')
  async getBannerFlag(
    @Query('page') page: number,
    @Query('limit') limit: number,
    @Param('flag') flag: number
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 관리자 - 온라인 서점 조회
   */
  @Get('/onlinestore')
  async getOnlineStore(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 관리자 - 온라인 서점 특정 ID 조회
   */
  @Get('/onlinestore/{id}')
  async getOnlineStoreId(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 온라인 서점 삭제
   */
  @Delete('/onlinestore/{id}')
  async deleteOnlineStore(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 온라인 서점 수정
   */
  @Patch('/onlinestore/{id}')
  async patchOnlineStore(
    @Param('id') id: number,
    @Body()
    data: {
      name: string;
      urlOnline: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 온라인 서점 이미지 수정
   */
  @Patch('/onlinestore/{id}/attaches')
  async patchOnlineStoreattache(
    @Param('id') id: number,
    @Form()
    data: any
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 온라인 서점 등록
   */
  @Post('/onlinestore')
  async postOnlineStore(@Body() data: { name: string; urlOnline: string }): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 오프라인 서점 조회
   */
  @Get('/offlinestore')
  async getOfflineStore(@Query('page') page: number, @Query('limit') limit: number): Promise<any> {
    return Promise.reject(new Error('Not implemented'));
  }

  /*
   * 관리자 - 오프라인 서점 삭제
   */
  @Delete('/offlinestore/{id}')
  async deleteOfflineStore(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 오프라인 서점 등록
   */
  @Post('/offlinestore')
  async postOfflineStore(
    @Body()
    data: {
      name: string;
      tel: string;
      address: string;
      district: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 오프라인 서점 특정 ID 조회
   */
  @Get('/offlinestore/{id}')
  async getOfflineStoreId(@Param('id') id: number): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 관리자 - 온라인 서점 수정
   */
  @Patch('/offlinestore/{id}')
  async patchOfflineStore(
    @Param('id') id: number,
    @Body()
    data: {
      name: string;
      tel: string;
      address: string;
      district: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 아이디 찾기
   */
  @Post('/users/find/Id')
  async postFindUsername(
    @Body()
    data: {
      email: string;
      name: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 비밀번호 찾기
   */
  @Post('/users/find/pwd')
  async postFindPassword(
    @Body()
    data: {
      username: string;
      email: string;
      phone: string;
    }
  ): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }

  /*
   * 사용자 - 주문내역조회
   */
  @Get('/orders/own/detail')
  async getOrdersOwnDetail(@Query('page') page: any, @Query('limit') limit: any): Promise<any> {
    return Promise.reject(new Error('Not implemented.'));
  }
}
export default new Server();
